import React from 'react';
import { RegLoginRoutes } from '@/routing/RegLoginRouter';
import { InvestorRoutes } from '@/routing/InvestorRouter';
import { AdminRoutes } from '@/routing/AdminRouter';

export const RootRouter = ({ routerMode }) => {
  return (
    <>
      {routerMode === 'reg' && <RegLoginRoutes />}
      {routerMode === 'investor' && <InvestorRoutes />}
      {(routerMode === 'admin' || routerMode === 'superAdmin') && <AdminRoutes />}
    </>
  );
};
